import * as yup from 'yup';
import { provinces, states, roleValues } from './constants';

// Validation taken from https://stackoverflow.com/a/55866098
export const rePhoneNumber =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?(?:\s?(ext|x)\.?\s?\d{1,6})?$/;

const createMaxMessage = (max) => `The ${max} character limit was exceeded.`;
const createMinMessage = (min) => `Must contain at least ${min} characters`;
const requiredMessage = 'This field is required.';
const zipRegExp =
  /^\d{5}(-{0,1}\d{4})?|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
const personalEmailRegExp =
  /.+@(outlook|gmail|yahoo|inbox\.com|icloud|zoho|mail\.com|hotmail)\.com$/gi;
const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;

const email = yup
  .string()
  .max(320, createMaxMessage(320))
  .email('This is an invalid email address.');
const phone = yup
  .string()
  .max(30, createMaxMessage(30))
  .min(10, 'This is an invalid phone number.')
  .matches(rePhoneNumber, 'Phone number is not valid.');
const usZip = yup
  .string()
  .max(16, createMaxMessage(16))
  .matches(zipRegExp, 'This is an invalid zip code.');
const zip = yup.string().max(16, createMaxMessage(16));
const name = yup.string().max(128, createMaxMessage(128));
const street1 = yup.string().max(128, createMaxMessage(128));
const street2 = yup.string().max(128, createMaxMessage(128));
const country = yup.string().max(64, createMaxMessage(64));
const countryCode = yup.string().max(2, createMaxMessage(2));
const city = yup.string().max(64, createMaxMessage(64));
const state = yup.string().oneOf(
  Object.keys(states).map((e) => states[e]),
  'Not a valid state selection.'
);
const password = yup.string().max(64, createMaxMessage(64));
const buyerPasswordRegex = /(?=.*?[0-9])(?=.*?[A-Za-z]).+/;
const buyerPassword = yup
  .string()
  .min(8, createMinMessage(8))
  .max(64, createMaxMessage(64))
  .matches(
    buyerPasswordRegex,
    'Must contain at least one number and one letter.'
  );
const province = yup
  .string()
  .oneOf(Object.keys(provinces).map((e) => provinces[e]));
const firstName = yup.string().max(64, createMaxMessage(64));
const lastName = yup.string().max(64, createMaxMessage(64));
const companyName = yup.string().max(128, createMaxMessage(128));
const intention = yup.string();
const role = yup.string().oneOf(Object.keys(roleValues));
const showPassword = yup.boolean();
const capabilitiesSchema = yup.object().shape({
  supported_processes: yup
    .array()
    .min(1, 'You must select a process.')
    .required('You must select a process.'),
});
const taxId = yup
  .string()
  .length(9, 'Tax ID/EIN should have 9 digits.')
  .matches(/^[0-9]+$/, 'Tax ID/EIN must be a number.');

const duns = yup
  .string()
  .length(9, 'DUNS Number should have 9 digits.')
  .matches(/^[0-9]+$/, 'DUNS Number must be a number.');

const numberValidation = yup
  .string()
  .matches(/^[0-9]+(\.?)[0-9]+$/, 'This field must be a number.');

const genericStringValidation = yup.string().max(128, createMaxMessage(128));

export {
  createMaxMessage,
  requiredMessage,
  zipRegExp,
  personalEmailRegExp,
  city,
  companyName,
  country,
  countryCode,
  email,
  firstName,
  lastName,
  name,
  password,
  buyerPassword,
  phone,
  province,
  intention,
  role,
  showPassword,
  state,
  street1,
  street2,
  usZip,
  zip,
  capabilitiesSchema,
  numberValidation,
  taxId,
  duns,
  genericStringValidation,
  emailRegex,
};
